import { render, staticRenderFns } from "./ElectricalDamageTypeSection.vue?vue&type=template&id=fe70b200&scoped=true"
import script from "./ElectricalDamageTypeSection.vue?vue&type=script&lang=ts"
export * from "./ElectricalDamageTypeSection.vue?vue&type=script&lang=ts"
import style0 from "./ElectricalDamageTypeSection.vue?vue&type=style&index=0&id=fe70b200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe70b200",
  null
  
)

export default component.exports